<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import filesize from 'filesize';
  import moment from 'moment';
  import { CalendarCheckIcon, RhombusIcon } from '../icons.js';
  
  export default {
    
    props: {
      orderId: {
        default: null
      }
    },
    
    created () {
      this.getReviewFiles();
    },
    
    computed: {
      
      selectedFilesCount () {
        return this.files.filter(file => file.selected).length;
      }
    },
    
    methods: {

      showTaskForm () {
        this.taskFormActive = true;
      },
      
      showBasicTaskForm () {
        this.basicTaskFormActive = true;
      },
      
      closeTaskForm () {
        this.taskFormActive = false;
      },
      
      closeBasicTaskForm () {
        this.basicTaskFormActive = false;
      },
      
      convertFileSize ($size) {
        return filesize($size);
      },
      
      formatFileDate ($time) {
        return moment($time).format('D-MMMM-YYYY h:mm:ss a');
      },
      
      toggleAllFiles () {
        //@TODO - why is there a delay with the result??
        setTimeout(() => {
          this._toggleFiles(this.allFilesSelected);
        }, 100)
      },
      
      _toggleFiles (state) {
        for (let i = 0; i < this.files.length; i++) {
          this.$set(this.files, i, Object.assign({}, this.files[i], {selected: state}));
        }
      },
      
      taskCreated () {
        //deselect all files
        this.toggleAllFiles(false);
        
        this.getReviewFiles();
        
        this.$emit('task-created');
      },
      
      getReviewFiles () {
        axios({
          url: `/review/files/${this.orderId}`,
          
          transformResponse: [(data) => {
            return {data: _.toArray(JSON.parse(data).data)};
          }]
        }).then((result) => {
          this.files = result.data.data || [];
          console.log('the result', result)
        })
      }
    },
    
    template,
    
    data () {
      
      return {
        reviewers: [],
        
        files: [],
        
        taskFormActive: false,
        
        basicTaskFormActive:  false,
        
        isActive: false,
        
        allFilesSelected: false
      }
    },
    
    components: {
      CalendarCheckIcon
      ,RhombusIcon
    }
  };
</script>
